import React, { useEffect, useState } from 'react';
import { Bling as GPT } from "react-gpt";
import CrosswordGame from "./crossword-game/CrosswordGame";

function App() {
  const [interstitial_is_open, setInterstitialIsOpen] = useState(true);
  const [loadBanner, setLoadBanner] = useState(false);
  useEffect(() => {
    const cookie = document.cookie.split(';').find(cookie => cookie.includes('usuarilogatcapab'));
    if (!cookie) return setLoadBanner(true)
    const cookieValue = decodeURIComponent(cookie.split('=')[1]);
    setLoadBanner(cookieValue === '[]');
  }, []);

  return (<>
    <div className="vil_minimots_app">
      <iframe id="vlw_header" title="vlw_header" src="/wp-content/themes/vilaweb/template-parts/header-include.php" onLoad={() => { window.scrollTo(0, 0) }} frameBorder="0" width="100%" height="60"></iframe>
      {loadBanner && <div id='div-gpt-ad-1684157982862-0' className="center_banner" style={{ minWidth: 320, minHeight: 90 }}>
        <GPT adUnitPath='/75638159/77111644467' sizeMapping={[{ viewport: [0, 0], slot: [320, 100] }, { viewport: [1024, 0], slot: [970, 90] }]} />
      </div>}
      {/* <InterestialBanner setInterstitialIsOpen={setInterstitialIsOpen} /> */}
      <CrosswordGame />
      <iframe id="vlw_footer" title="vlw_footer" src="/wp-content/themes/vilaweb/template-parts/footer-include.php" frameBorder="0" width="100%" height="auto"></iframe>
    </div>
  </>
  );
}

const InterestialBanner = ({ setInterstitialIsOpen }) => {
  const interstitialBannerSize = { minWidth: 320, minHeight: 480, maxWidth: 800, maxHeight: 600 };

  const [display, setDisplay] = useState(true);
  const [loadBanner, setLoadBanner] = useState(false);
  // load interstitial banner if user is not logged in
  useEffect(() => {
    const cookie = document.cookie.split(';').find(cookie => cookie.includes('usuarilogatcapab'));
    if (!cookie) return setLoadBanner(true)
    const cookieValue = decodeURIComponent(cookie.split('=')[1]);
    setLoadBanner(cookieValue === '[]');
  }, []);

  // render of the interstitial banner, with a close button and blurred background
  return (loadBanner && display &&
    <div className={`bg-black/50 fixed h-screen inset-0 layer-popup overflow-y-auto w-screen z-50${display ? '' : ' hidden'}`}>
      <div className="center_banner bg-white border-[rgba(255,102,0,1)] dark:bg-black-900 border-t-2 max-w-4xl md:mb-24 md:mt-32 mx-auto px-4 py-12 relative rounded-bl-2xl rounded-br-2xl w-full">
        <div className="absolute right-4 top-4">
          <button className="cursor-pointer h-6 toggle-popup w-6" onClick={() => {
            setDisplay(false)
            setInterstitialIsOpen(false)
          }}>
            <svg width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M17.834 4.84L4.84 17.835a.188.188 0 000 .265l1.06 1.06a.188.188 0 00.265 0L19.16 6.167a.188.188 0 000-.265l-1.06-1.06a.188.188 0 00-.265 0z" fill="currentColor"></path><path d="M19.16 17.834L6.166 4.84a.188.188 0 00-.265 0L4.841 5.9a.188.188 0 000 .265L17.834 19.16a.188.188 0 00.265 0l1.06-1.061a.188.188 0 000-.265z" fill="currentColor"></path></svg>
          </button>
        </div>
        <GPT id="div-gpt-ad-1684409543111-0" adUnitPath="/75638159/54546548787741" sizeMapping={[{ viewport: [0, 0], slot: [320, 480] }, { viewport: [1024, 0], slot: [800, 600] }]} />
      </div >
    </div >
  )
}

export default App;